module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Align-right-8cefa69dc420c6e58cdcf2a2586fbc2e.svg";